import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101514 89771"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:1471.22}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270474848">
        <path
          d="M2366 35074c2176-2173 5698-2173 7874 0s2176 5699 0 7874c-2176 2174-5698 2174-7874 0-2173-2173-2173-5698 0-7874zM17182 49895c2176-2176 5701-2176 7876 0 2174 2173 2174 5698 0 7874-2176 2173-5701 2173-7876 0-2173-2176-2173-5701 0-7874zM32003 64711c2176-2176 5701-2176 7874 0 2176 2173 2176 5698 0 7871-2173 2176-5698 2176-7874 0-2176-2170-2176-5698 0-7871zM46820 79531c2176-2176 5698-2176 7874 0 2176 2173 2176 5699 0 7872-2173 2176-5698 2176-7874 0-2173-2173-2173-5699 0-7872zM99148 35074c-2173-2173-5698-2173-7874 0-2173 2173-2173 5699 0 7874 2176 2174 5701 2174 7874 0 2173-2173 2173-5698 0-7874zM84329 49895c-2173-2176-5698-2176-7874 0-2173 2173-2173 5698 0 7874 2176 2173 5701 2173 7874 0 2176-2176 2176-5701 0-7874zM69512 64711c-2173-2176-5697-2176-7872 0-2176 2173-2176 5698 0 7871 2175 2176 5699 2176 7872 0 2176-2170 2176-5698 0-7871z"
          className="fill stroke1s"
          style={{
            strokeWidth: 1471.22,
          }}
        />
        <path
          d="M54694 79531c-2173-2176-5698-2176-7874 0-2176 2173-2176 5699 0 7872 2176 2176 5698 2176 7874 0 2173-2173 2173-5699 0-7872zM2366 2366c2176-2173 5698-2173 7874 0 2176 2176 2176 5698 0 7874-2176 2173-5698 2173-7874 0-2173-2176-2173-5698 0-7874zM17182 17185c2176-2173 5701-2173 7876 0 2174 2173 2174 5698 0 7874-2176 2173-5701 2173-7876 0-2173-2176-2173-5701 0-7874zM32003 32003c2176-2176 5701-2176 7874 0 2176 2173 2176 5698 0 7874-2173 2173-5698 2173-7874 0-2176-2176-2176-5701 0-7874zM46820 46820c2176-2174 5698-2174 7874 0s2176 5699 0 7872c-2173 2176-5698 2176-7874 0-2173-2171-2173-5696 0-7872zM99148 2366c-2173-2173-5698-2173-7874 0-2173 2176-2173 5698 0 7874 2176 2173 5701 2173 7874 0 2173-2176 2173-5698 0-7874zM84329 17185c-2173-2173-5698-2173-7874 0-2173 2173-2173 5698 0 7874 2176 2173 5701 2173 7874 0 2176-2176 2176-5701 0-7874zM69512 32003c-2173-2176-5697-2176-7872 0-2176 2173-2176 5698 0 7874 2175 2173 5699 2173 7872 0 2176-2176 2176-5701 0-7874z"
          className="fill stroke1s"
          style={{
            strokeWidth: 1471.22,
          }}
        />
        <path
          d="M54694 46820c-2173-2174-5698-2174-7874 0s-2176 5699 0 7872c2176 2176 5698 2176 7874 0 2173-2171 2173-5696 0-7872z"
          className="fill stroke1s"
          style={{
            strokeWidth: 1471.22,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
